import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

import { Post } from '@tribeplatform/gql-client/types'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { getPostFieldValue } from '../../utils/post'
import { Reply } from './Reply'

export const ReplyWithParent = ({ reply }: { reply: Post }) => {
  const { generatePostPath } = useSpaceUtil()
  const rootPost = reply?.repliedTos?.[reply?.repliedTos.length - 1]

  const rootPostLink = generatePostPath(reply?.space, rootPost, reply)
  const rootPostTitle =
    getPostFieldValue(rootPost, 'title') ||
    getPostFieldValue(rootPost, 'question')

  return (
    <div>
      <div className="text-basicSurface-500 mb-2 px-1">
        Replied to{' '}
        <Link to={rootPostLink} className="font-medium text-basicSurface-900">
          {rootPostTitle}
        </Link>{' '}
        {dayjs(reply.createdAt).fromNow()}
      </div>

      <Card>
        <Card.Content>
          <Reply reply={reply} canReply={false} />
        </Card.Content>
      </Card>
    </div>
  )
}
